
import { defineComponent } from "vue"
import MatchPoolsForm from "@/components/match_pools/Form.vue"

export default defineComponent({
  components: {
    MatchPoolsForm
  }
})
